import {useI18n} from '@yandex-delivery/core/i18n'
import {Typography} from '@yandex-delivery/ui'
import React, {type ReactNode} from 'react'

import {type TariffsCountry} from '../../api'
import type {Path} from '../../types'
import styleClasses from './classes@desktop.module.css'
import {CountryButton} from './CountrySelector/index@desktop'

type Props = {
  subtitle?: ReactNode
  path: Path
  countries: TariffsCountry[]
}

export function Header({subtitle, ...restProps}: Props) {
  const i18n = useI18n()

  return (
    <div className={styleClasses.header}>
      <div className={styleClasses.title}>
        <Typography density="normal" level="title2" weight="bold">
          {i18n('tariffs-v3.header.title', 'Тарифы для бизнеса')}
        </Typography>
        <CountryButton {...restProps} />
      </div>
      {subtitle && <div className={styleClasses.subtitle}>{subtitle}</div>}
    </div>
  )
}
